


























import { Vue, Component, Prop, Ref, Emit } from "vue-property-decorator";
import { formatLocationInfo } from "@/utils/LocalisationHelper";
import MemberClientDialog from "../client/MemberClientDialog.vue";
import { MemberClientDetails } from "@/data/models/Client";
import { ExternalSystem } from "@/data/models/ExternalSystem";

@Component({
  components: {
    "member-client-dialog": MemberClientDialog,
  },
})
export default class MemberClientItemComponent extends Vue {
  @Prop() readonly memberClient!: MemberClientDetails;
  @Prop() elevation!: number;
  @Prop()
  externalSystems!: ExternalSystem[];

  @Ref("memberClientDialog")
  memberClientDialog!: MemberClientDialog;

  @Emit("onSuccess")
  onSuccess(message: string) {
    this.$emit("onSuccess", message);
  }

  @Emit("onError")
  onError(message: string) {
    this.$emit("onError", message);
  }

  async openDetails() {
    await this.memberClientDialog.show(this.memberClient, this.externalSystems);
  }

  get memberClientAddress() {
    const memberClient = this.memberClient;

    return formatLocationInfo({
      zipCode: memberClient.zip,
      city: memberClient.city,
      street: memberClient.street,
      houseNumber: memberClient.houseNumber
    });
  }
}
